'use client'

import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useMessage } from '@/src/context/message/message-context'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import '@/src/extensions/string'
import ActionButton from '@/src/components/misc/action-elements/action-button/action-button'
import ActionInput from '@/src/components/misc/action-elements/action-input/action-input'
import { useAppAccessToken } from '@/src/context/app-access-token/app-access-token-context'
import { CustomerService } from '@/src/services/merchant/customer-service'
import { Overlay } from '@/src/components/helpers/overlays/overlay'

interface Props {
    email: string
}

export default function ForgotPassword(props: Props) {
    const { showMessage } = useMessage()
    const { merchantSummary } = useMerchant()

    const [email, setEmail] = useState(props.email)
    const [isLoading, setIsLoading] = useState(false)
    const { appAccessToken } = useAppAccessToken()

    const sendEmail = async () => {
        try {
            setIsLoading(true)

            if (!email)
                return showMessage('Informe um e-mail.')

            const response = await CustomerService.forgotPassword(merchantSummary?.id!, email, appAccessToken)

            if (!response.success)
                throw Error(response.errorMessage)

            showMessage('Um link para troca de senha foi enviado ao seu e-mail.', { type: 'success' })
            Overlay.dismiss()
        }
        catch (e) {
            showMessage((e as Error).message, { type: 'danger', error: e as Error })
        }
        finally {
            setIsLoading(false)
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.loginDataArea}>
                <div className={styles.inputArea}>
                    <label>E-mail</label>
                    <ActionInput
                        type="email"
                        autoComplete='on'
                        name="email"
                        value={email}
                        maxLength={100}
                        onChange={(e) => setEmail(e.target.value)}
                        classNameContainer={styles.dataInput}
                    />
                </div>
                <small>Informe seu e-mail e enviaremos um link para alteração de senha da sua conta.</small>
                <div className={styles.btns}>
                    <ActionButton
                        onClick={sendEmail}
                        size='medium'
                        isLoading={isLoading}
                        className={`${styles.btn} font-xmd`}
                        type='submit'
                        disabled={isLoading}
                    >
                        Receber meu link
                    </ActionButton>
                    <ActionButton onClick={() => Overlay.dismiss()} size='medium' theme='inverted' className={`${styles.btn} font-xmd`} type='submit'>
                        Cancelar
                    </ActionButton>
                </div>
            </div>
        </div>
    )
}